import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductSection } from './components/ProductSection';
import { DetailsSection } from './components/DetailsSection';
import { CheckoutSection } from './components/CheckoutSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-gray-50 font-inter selection:bg-brandRed selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <ProductSection data-id="element-4" />
        <DetailsSection data-id="element-5" />
        <CheckoutSection data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}